import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

// Define the Yup validation schema
const validationSchema = yup.object({
    userName: yup.string().required("User Name is required"),
    oldPassword: yup.string().required("Old Password is required"),
    newPassword: yup.string().required("Old Password is required").min(8, "Password must be at least 8 characters"),
    confirmPassword: yup.string().required("Confirm Password is required").oneOf([yup.ref("newPassword")], "Password and Confirm Password must match")
}).required()

export default function ChangePassword() {
    const [loading, setLoading] = useState('');
    const navigate = useNavigate();
    const { secureFetch } = useAuth();

    // Initialize React Hook Form with the Yup resolver
    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema)
    })

    const onSubmit = async (data) => {
        //alert('hi'); window.event.preventDefault();
        try {
            setLoading('loading');
            const options = {
                method: 'POST',
                headers: {
                    //"Content-Type": "application/x-www-form-urlencoded"
                    'Content-Type': 'application/json'
                },
                //body: new URLSearchParams(params).toString()
                body: JSON.stringify(data)
            };
            const response = await secureFetch('api/auth/ChangePassword', options);
            const message = await response.text();
            alert(message);
            navigate("/");
        } catch (err) {
            console.error('Change Password failed:', err);
        } finally {
            setLoading('');
        }
    };

    return (
        <>
            <h3>Change password</h3>
            <div className={`row ${loading}`}>
                <div className="col-md-6 col-md-offset-6" >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div asp-validation-summary="ModelOnly" className="text-danger"></div>
                        <div className="form-floating mb-2">
                            <input {...register("userName")} className="form-control" autocomplete="off" aria-required="true" />
                            <label for="userName" className="form-label">User Name</label>
                            <div>&nbsp; {errors.userName && <span className="text-danger">{errors.userName.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("oldPassword")} className="form-control" type="password" autocomplete="current-password" aria-required="true" />
                            <label for="oldPassword" className="form-label">Old Password</label>
                            <div>&nbsp; {errors.oldPassword && <span className="text-danger">{errors.oldPassword.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("newPassword")} className="form-control" type="password" autocomplete="new-password" aria-required="true" />
                            <label for="newPassword" className="form-label">New Password</label>
                            <div>&nbsp; {errors.newPassword && <span className="text-danger">{errors.newPassword.message}</span>}</div>
                        </div>
                        <div className="form-floating mb-2">
                            <input {...register("confirmPassword")} className="form-control" type="password" autocomplete="new-password" aria-required="true" />
                            <label for="confirmPassword" className="form-label">Confirm Password</label>
                            <div>&nbsp; {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword.message}</span>}</div>
                        </div>
                        <button type="submit" className="w-100 btn btn-lg btn-primary">Update password</button>
                    </form>
                    {loading && <div className='overlay'></div>}
                </div>
            </div>
        </>
    );
}


